const AUTH_TOKEN_KEY = "relance-auth-token";

function canUseStorage(): boolean {
  return typeof window !== "undefined" && typeof window.sessionStorage !== "undefined";
}

export function getStoredAuthToken(): string | null {
  if (!canUseStorage()) {
    return null;
  }

  return window.sessionStorage.getItem(AUTH_TOKEN_KEY);
}

export function setStoredAuthToken(token: string | null): void {
  if (!canUseStorage()) {
    return;
  }

  if (token) {
    window.sessionStorage.setItem(AUTH_TOKEN_KEY, token);
    return;
  }

  window.sessionStorage.removeItem(AUTH_TOKEN_KEY);
}

export function persistAuthToken(input: {
  headers?: Headers;
  body?: {
    token?: string | null;
  };
}): string | null {
  const headerToken = input.headers?.get("set-auth-token") ?? null;
  const nextToken = headerToken ?? input.body?.token ?? null;
  setStoredAuthToken(nextToken);
  return nextToken;
}
